import * as React from 'react';
import Layout from '../components/Utilities/Layout';
import { Alert, Box, Button, ButtonProps, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Grid, LinearProgress, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Menu, MenuItem, Stack, Switch, Typography } from '@mui/material';
import Common from '../utilities/common';
import $ from "jquery";
import NombrePilaVariacionNew from './NombrePilaVariacionNew';
import { NombrePilaVariacion } from './NombrePilaVariacion';
import { DataGrid, GridRowSelectionModel, GridRowId, GridCsvExportOptions, GridCsvGetRowsToExportParams, gridExpandedSortedRowIdsSelector, useGridApiContext, GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import NombrePilaVariacionDelete from './NombrePilaVariacionDelete';
import NombrePilaVariacionEdit from './NombrePilaVariacionEdit';
import MedicalInformationOutlinedIcon from '@mui/icons-material/MedicalInformationOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import SecurityTrimmer from '../components/Utilities/SecurityTrimmer';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { Entity, PermissionLevel } from '../utilities/Permisos';
import EntitySettings from '../components/EntitySettings';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import FeatureManager from '../components/Utilities/FeatureManager';

const getFilteredRows = ({ apiRef }: GridCsvGetRowsToExportParams) =>
    gridExpandedSortedRowIdsSelector(apiRef);

const ExportButton = () => {
    const apiRef = useGridApiContext();
  
    const handleExport = (options: GridCsvExportOptions) =>
      apiRef.current.exportDataAsCsv(options);
  
    const buttonBaseProps: ButtonProps = {
      color: 'primary',
      size: 'small',
      startIcon: <FileDownloadOutlinedIcon />,
    };
  
    return (
        <Button
            {...buttonBaseProps}
            onClick={() => handleExport({ getRowsToExport: getFilteredRows, fileName: 'variaciones_nombres_de_pila' })}
        >
            Exportar CSV
        </Button>
    );
}

export interface INombrePilaVariacionesState {
    data: NombrePilaVariacion[];
    loading: boolean;
    selectedSex: string;
    openNewForm: boolean;
    openEditForm: boolean;
    openDeleteForm: boolean;
    openImportProgress: boolean;
    selectedNombrePilaVariacion: GridRowId[];
    progress: number;
    progressMessage: string;
    checkBoxSelection: boolean;
    errors: string[];
    rowSelected: null | HTMLElement;
    openRowMenu: boolean;
}

export default class NombrePilaVariacionesView extends React.Component<{}, INombrePilaVariacionesState> {
    _file: any;
    _fileContent: any[] = [];
    _errors: string[] = [];

    public constructor(props: {}) {
        super(props);

        this.state = {
            data: [],
            selectedSex: 'mujer',
            loading: true,
            openNewForm: false,
            openEditForm: false,
            openDeleteForm: false,
            openImportProgress: false,
            selectedNombrePilaVariacion: [],
            checkBoxSelection: false,
            progress: 0,
            progressMessage: '',
            rowSelected: null,
            openRowMenu: false,
            errors: []
        };
    }

    componentDidMount(): void {
        this.Get();
    }

    public render(): React.ReactElement<{}> {
        return (
            <FeatureManager entidad={Entity.VariacionesNombresPila} operacion='Ver' showBuyOption>
                <SecurityTrimmer entity={Entity.VariacionesNombresPila} permission={PermissionLevel.Ver} noAccessMessage='No tiene permisos para ver este contenido.'>
                    <Layout breadcrumb={
                        [
                            {
                                title: 'Inicio',
                                url: '/'
                            },
                            {
                                title: 'Variaciones de nombres de pila',
                                url: ''
                            }
                        ]
                    }>
                        <Box className='stepper'>
                            <Grid container>
                                <Grid item xs={1}>
                                    <Typography>
                                        <MedicalInformationOutlinedIcon className='mainIcon'/>
                                    </Typography>
                                </Grid>
                                <Grid item xs={9}>
                                    <Typography className='mainTitle'>
                                    Variaciones de nombres de pila
                                    </Typography>
                                </Grid>
                                <Grid item xs={2} className='entitySettings'>
                                    <EntitySettings entity={Entity.VariacionesNombresPila}/>
                                </Grid>
                            </Grid>
                        </Box>
                        <Box className='main'>
                            {
                                this.state.loading && (
                                    <div style={{textAlign: 'center', marginTop: '40px'}}>
                                        <CircularProgress />
                                    </div>
                                )
                            }
                            {
                                !this.state.loading && this.state.data.length == 0 && (
                                    <Alert style={{marginTop: '40px'}} severity="warning">No se han encontrado resultados.</Alert>
                                )
                            }
                            {
                                !this.state.loading && this.state.data.length > 0 && (
                                    <DataGrid
                                        autoHeight
                                        loading={this.state.data.length == 0}
                                        slots={{ toolbar: this.CustomToolbar.bind(this) }}
                                        slotProps={{ pagination: { labelRowsPerPage: 'Filas por página' } }}
                                        rows={this.state.data}
                                        hideFooter={this.state.data.length <= 30}
                                        columns={this.GetColumns()}
                                        initialState={{
                                            pagination: {
                                                paginationModel: { page: 0, pageSize: 30 },
                                            },
                                        }}
                                        pageSizeOptions={[30, 60, 100]}
                                        checkboxSelection={this.state.checkBoxSelection}
                                        onRowSelectionModelChange={(row: GridRowSelectionModel) => {
                                            this.setState({
                                                selectedNombrePilaVariacion: row,
                                                openNewForm: false,
                                                openImportProgress: false,
                                                openDeleteForm: false,
                                                openEditForm: false
                                            });
                                        }}
                                    />
                                )
                            }
                        </Box>
                        <NombrePilaVariacionNew open={this.state.openNewForm} onSave={this.Get.bind(this)} />
                        <NombrePilaVariacionDelete open={this.state.openDeleteForm} id={this.state.selectedNombrePilaVariacion as number[]} onDelete={this.Get.bind(this)} />
                        <NombrePilaVariacionEdit open={this.state.openEditForm} onSave={this.Get.bind(this)} selectedItem={this.GetSelectedNombrePilaVariacion()}/>
                        <Dialog open={this.state.openImportProgress} fullWidth>
                            <DialogTitle>
                                Importando nombres de pila
                            </DialogTitle>
                            <DialogContent>
                                <Grid item xs={12} style={{padding: '20px 10px'}}>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <Box sx={{ width: '100%', mr: 1 }}>
                                            <LinearProgress variant="determinate" value={this.state.progress} />
                                        </Box>
                                        <Box sx={{ minWidth: 35 }}>
                                            <Typography variant="body2" color="text.secondary">
                                                {
                                                    `${this.state.progress}%`
                                                }
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Grid>
                            </DialogContent>
                        </Dialog>
                        <Dialog open={this.state.errors.length > 0} fullWidth>
                            <DialogTitle>
                                Error
                            </DialogTitle>
                            <DialogContent>
                                <Typography variant='body2'>
                                    Se han producido los siguientes errores durante la importación:
                                </Typography>
                                <div className='errors'>
                                    <List>
                                        {
                                            this.state.errors.map((value: string, index: number) => {
                                                return (
                                                    <ListItem disablePadding>
                                                        <ListItemButton>
                                                            <ListItemIcon>
                                                                <CancelOutlinedIcon />
                                                            </ListItemIcon>
                                                            <ListItemText primary={value} />
                                                        </ListItemButton>
                                                    </ListItem>
                                                )
                                            })
                                        }
                                    </List>
                                </div>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => {
                                    this.setState(
                                        {
                                            errors: []
                                        }
                                    );
                                }}>Ok</Button>
                            </DialogActions>
                        </Dialog>
                        <Menu
                            anchorEl={this.state.rowSelected}
                            open={this.state.openRowMenu}
                            onClose={() => {
                                this.setState(
                                    {
                                        rowSelected: null,
                                        openRowMenu: false
                                    }
                                );
                            }}
                        >
                            <MenuItem onClick={() => {
                                    this.setState(
                                        {
                                            openNewForm: false,
                                            openImportProgress: false,
                                            openEditForm: true,
                                            openDeleteForm: false,
                                            openRowMenu: false
                                        }
                                    );
                            }}>
                                <ListItemIcon>
                                    <EditIcon fontSize="small" />
                                </ListItemIcon>
                                <ListItemText>Modificar</ListItemText>
                            </MenuItem>
                            <MenuItem onClick={() => {
                                    this.setState(
                                        {
                                            openNewForm: false,
                                            openImportProgress: false,
                                            openEditForm: false,
                                            openDeleteForm: true,
                                            openRowMenu: false
                                        }
                                    );
                            }}>
                                <ListItemIcon>
                                    <DeleteOutlineOutlinedIcon fontSize="small" />
                                </ListItemIcon>
                                <ListItemText>Eliminar</ListItemText>
                            </MenuItem>
                        </Menu>
                    </Layout>
                </SecurityTrimmer>
            </FeatureManager>
        )
    }

    private GetSelectedNombrePilaVariacion(): NombrePilaVariacion | undefined {
        return this.state.data.find((value: NombrePilaVariacion) => {
            return value.id == this.state.selectedNombrePilaVariacion[0] as number;
        });
    }

    private Get(): void {
        this.setState({
            loading: true
        });

        let url = `${Common.END_POINT}/masters/nombrespilavariacion`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    data: response,
                    openNewForm: false,
                    openImportProgress: false,
                    openDeleteForm: false,
                    openEditForm: false,
                    selectedNombrePilaVariacion: [],
                    loading: false,
                    progress: 0
                }
            );
        })
    }

    private UploadFile(): void {
        let url = `${Common.END_POINT}/excel/upload/withcolumnnames`;

        const data = new FormData();
        data.append('file', this._file);
        $.ajax((
            {
                url: url,
                type: "POST",
                data: data,
                processData: false,
                contentType: false,
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            console.log(response);
            this.setState(
                {
                    openImportProgress: true
                }
            );

            this._fileContent = response;
            this.Import(0);
        })
    }
    
    private Import(index: number): void {
        if(index >= this._fileContent.length) {
            this.Get();
            this.setState({
                errors: this._errors
            });
            return;
        }

        let url = `${Common.END_POINT}/masters/nombrespilavariacion`;
        $.ajax((
            {
                url: url,
                type: "POST",
                data: JSON.stringify(this._fileContent[index]),
                dataType: "json",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any) => {
            if(response[0].error != null) {
                this._errors.push(response[0].error);
            }

            const newIndex = index + 1;
            this.setState(
                {
                    progressMessage: this._fileContent[index]['nombre'],
                    progress: Math.round((newIndex / this._fileContent.length) * 100)
                }
            );

            this.Import(newIndex);
        });
    }

    private CustomToolbar() {
        return (
            <Stack direction={'row'} alignItems={'center'} className='toolbar' gap={'20px'}>
                <FeatureManager entidad={Entity.VariacionesNombresPila} operacion='Crear'>
                    <SecurityTrimmer entity={Entity.Provincias} permission={PermissionLevel.Crear}>
                        <Button startIcon={<AddOutlinedIcon />} variant="contained" onClick={() => {
                            this.setState(
                                {
                                    openNewForm: true,
                                    openImportProgress: false,
                                    openEditForm: false,
                                    openDeleteForm: false
                                }
                            );
                        }}>
                            Nuevo
                        </Button>
                    </SecurityTrimmer>
                </FeatureManager>
                {
                    this.state.selectedNombrePilaVariacion.length == 1 && (
                        <FeatureManager entidad={Entity.VariacionesNombresPila} operacion='Editar'>
                            <SecurityTrimmer entity={Entity.Provincias} permission={PermissionLevel.Editar}>
                                <Button startIcon={<EditOutlinedIcon />} variant="text" onClick={() => {
                                    this.setState(
                                        {
                                            openNewForm: false,
                                            openImportProgress: false,
                                            openEditForm: true,
                                            openDeleteForm: false
                                        }
                                    );
                                }}>
                                    Modificar
                                </Button>
                            </SecurityTrimmer>
                        </FeatureManager>
                    )
                }
                {
                    this.state.selectedNombrePilaVariacion.length > 0 && (
                        <FeatureManager entidad={Entity.VariacionesNombresPila} operacion='Eliminar'>
                            <SecurityTrimmer entity={Entity.Provincias} permission={PermissionLevel.Eliminar}>
                                <Button startIcon={<DeleteOutlineOutlinedIcon />} variant="text" onClick={() => {
                                    this.setState(
                                        {
                                            openNewForm: false,
                                            openImportProgress: false,
                                            openEditForm: false,
                                            openDeleteForm: true
                                        }
                                    );
                                }}>
                                    Eliminar
                                </Button>
                            </SecurityTrimmer>
                        </FeatureManager>
                    )
                }
                {
                    ExportButton()
                }
                <Stack direction={'row'} style={{marginLeft: 'auto'}} justifyContent={'space-between'}>
                    <FeatureManager entidad={Entity.VariacionesNombresPila} operacion='Editar'>
                        <FormControlLabel control={<Switch defaultChecked={this.state.checkBoxSelection} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            this.setState(
                                {
                                    checkBoxSelection: event.target.checked,
                                    openNewForm: false,
                                    openImportProgress: false,
                                    openEditForm: false,
                                    openDeleteForm: false
                                }
                            );
                        }}/>} label={<Typography variant='body2' color={'text.secondary'}>Selección múltiple</Typography>} />
                    </FeatureManager>
                </Stack>
            </Stack>
        )
    }

    private RenderCellExpand(params: GridRenderCellParams<any, string>) {
        console.log(params);
        return (
            <React.Fragment>
                {
                    params.field == 'id' && (
                        Common.RenderCellMenuButton(params.value!, (event: React.MouseEvent<HTMLButtonElement>) => {
                            this.setState(
                                {
                                    rowSelected: event.currentTarget,
                                    openRowMenu: true
                                }
                            );
                        })
                    )
                }
                {
                    params.field == 'creadoPor' && (
                        Common.RenderUser(params.row, 'creadoPor')
                    )
                }
                {
                    params.field == 'modificadoPor' && (
                        Common.RenderUser(params.row, 'modificadoPor')
                    )
                }
                {
                    params.field == 'creado' && (
                        Common.RenderDate2(params.value!)
                    )
                }
                {
                    params.field == 'modificado' && (
                        Common.RenderDate2(params.value!)
                    )
                }
                {
                    params.field == 'sexo' && (
                        Common.RenderSex(params.value!)
                    )
                }
                {
                    params.field != 'id' && params.field != 'creadoPor' && params.field != 'creado' && params.field != 'modificado' && params.field != 'modificadoPor' && params.field != 'sexo' && (
                        params.value
                    )
                }
            </React.Fragment>
        );
    }

    public GetColumns(): GridColDef[] {
        const firstRow = this.state.data[0];
        const columns: GridColDef[] = [];
        const keys = Object.getOwnPropertyNames(firstRow);

        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            if(key != 'creadoPorAvatar' && key != 'modificadoPorAvatar' && key != 'creadoPorAvatarColor' && key != 'modificadoPorAvatarColor') {
                let column: GridColDef = {} as GridColDef;
                column.field = key;
                column.headerName = Common.GetDataFieldDisplayName(key);
                column.width = key == 'id' ? 100 : 200;
                column.renderCell = this.RenderCellExpand.bind(this);

                if(i == keys.length - 1) {
                    column.flex = 1;
                }

                columns.push(column);
            }
        }

        return columns;
    }
}